import Plugin from 'src/plugin-system/plugin.class';
export default class FeatureAccordionsPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.initialVisibleCount = 4;
    }
    init() {
        this.accordions = this.el.querySelectorAll('.accordion-item');
        this.loadMoreButton = this.el.querySelector('[data-feature-accordions-more]');
        this.resetButton = this.el.querySelector('[data-feature-accordions-reset]');
        this.initialVisibleCount = 4;
        if (this.accordions.length <= this.initialVisibleCount)
            return;
        this._registerEvents();
    }
    _registerEvents() {
        let visibleCount = this.initialVisibleCount;
        this._showLoadMoreButton();
        this.loadMoreButton?.addEventListener('click', () => {
            for (let i = visibleCount; i < visibleCount + this.initialVisibleCount && i < this.accordions?.length; i++) {
                this.accordions[i]?.classList.remove('tw-hidden');
            }
            visibleCount += 4;
            if (visibleCount >= this.accordions.length) {
                this._hideLoadMoreButton();
                this._showResetButton();
            }
        });
        this.resetButton?.addEventListener('click', () => {
            this.accordions.forEach((accordion, index) => {
                if (index < this.initialVisibleCount) {
                    accordion.classList.remove('tw-hidden');
                }
                else {
                    accordion.classList.add('tw-hidden');
                }
            });
            visibleCount = this.initialVisibleCount;
            this._hideResetButton();
            this._showLoadMoreButton();
        });
    }
    _showLoadMoreButton() {
        this.loadMoreButton?.classList.remove('tw-hidden');
    }
    _hideLoadMoreButton() {
        this.loadMoreButton?.classList.add('tw-hidden');
    }
    _showResetButton() {
        this.resetButton?.classList.remove('tw-hidden');
    }
    _hideResetButton() {
        this.resetButton?.classList.add('tw-hidden');
    }
}
